/*
 * top.js
 */
import './swiper-bundle.min.js';


/* TOP MV
------------------------------*/
(function() {

  //MV Slider
  const mvSwiper = new Swiper('.js-tp-mv-slider', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    loopAdditionalSlides: 1,
    speed: 2000,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    followFinger: false,
    pagination: {
      el: '.js-tp-mv-slider .swiper-pagination',
      clickable: true,
    },
  });

  //Pickup Slider

	//ブランドロゴスライド
	const pickupSwiper = new Swiper('.js-tp-pickup-slider', {
		effect: "slide",
		// slidesPerView: "auto",
		slidesPerView: 2.5,
		slidesPerGroup: 1,
		spaceBetween: 20,
		centeredSlides : false,
		disableOnInteraction: true,
		speed: 700,
		dots: true,
		loop: false,
		nested: true,
		breakpoints: {
					769: {
						slidesPerView: "auto",
						slidesPerGroup: 1,
						spaceBetween: 30,
					}
		},
		
		navigation: {
			nextEl: '.p-tp-pickup .swiper-button-next',
			prevEl: '.p-tp-pickup .swiper-button-prev',
		},
		pagination: {
			el: '.p-tp-pickup .swiper-pagination',
			type: 'progressbar',
		},
		thumbs: {
			swiper: pickupTextSwiper
		}
		
	});

	//ブランド説明テキストスライド
  const pickupTextSwiper = new Swiper('.js-tp-pickup-text', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
		thumbs: {
			swiper: pickupSwiper
		}
  });
  



  //Banner Slider
  const bannerSwiper = new Swiper('.js-tp-banner-slider', {
    effect: "slide",
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    spaceBetween: 20,
    centeredSlides : true,
    speed: 700,
    loop: true,
    breakpoints: {
      769: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 30,
        centeredSlides: false,
      }
    },
    
    navigation: {
      nextEl: '.p-tp-banner .swiper-button-next',
      prevEl: '.p-tp-banner .swiper-button-prev',
    }
  });


}());
